import { Video } from 'tabler-icons-react';
import { SidebarStoryDetails, VideoClip, StoryAccordionTitle } from 'Elements';
import styles from 'partials/story-box.module.scss';

export const StoryVideos = ({ story, videos, isOpen, onBack, type }) => {
	return (
		<SidebarStoryDetails
			story={story}
			isOpen={isOpen}
			onBack={onBack}
			type={type}>
			<StoryAccordionTitle
				isOpen
				title="ویدیو ها"
				icon={Video}
				hasExpand={false}
			/>
			<div className={styles.content}>
				{videos.map((video, idx) => {
					return (
						<VideoClip key={`${video.id}_${idx}`} video={video} />
					);
				})}
			</div>
		</SidebarStoryDetails>
	);
};
